import { PageRouteBuilder } from "@common/route/page-route-builder";
import { ListPrivilegedUsersPageComponent } from "./list-privileged-users-page.component";

export const listPrivilegedUsersRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-list-privileged-users", ListPrivilegedUsersPageComponent)
    .requiresLogin()
    .atUrl("/tools/list-privileged-users")
    .withTitle("List ASP.Net Privileged Users")
    .build();
